import { T_MongoDoc, T_MongoId } from "./_utils.types";
import { BusinessInfo, ClientDetails } from "./application.types";

enum LOAN_TYPES {
  MCA = "mca",
  LOAN = "bank loan",
  CREDIT_CARD = "credit card",
  OTHERS = "others",
}

export enum OCR_STATUS {
  PENDING = "pending", // in process
  RUNNING = "running",
  FAILED = "failed", // retrieval failed
  COMPLETED = "completed", // captured
  UPSTREAM = "upstream",
  STOPPED = "stopped",
  MODIFIED = "modified",
}

export enum FREQUENCY_TYPES {
  WEEKLY = "weekly",
  MONTHLY = "monthly",
  DAILY = "daily",
  YEARLY = "yearly",
}

export type LoanDto = {
  user: T_MongoId;
  loan_type: LOAN_TYPES;
  funded_amount?: number;
  funded_date?: Date;
  payback_amount?: number;
  currency: string;
  payments?: number;
  frequency?: FREQUENCY_TYPES;
  due_amount?: number;
  apr?: number;
  irr?: number;
  attachments: T_MongoId[];
  creditor_name: string;
  tenure: number;
  ocrState?: OCR_STATUS;
  client_details?: ClientDetails;
  business_info?: BusinessInfo;
};

export type LoanSchemaDto = LoanDto & T_MongoDoc;
export type CreateLoanDto = LoanSchemaDto;
export type UpdateLoanDto = Partial<LoanSchemaDto>;
